import { css } from '@emotion/react'
import styles, { typo } from '@mathflat/common/style'
import colors from '@mathflat/common/style/colors'

const {
  colors: { gray, borderColor },
} = styles

export default {
  input: [
    css`
      position: relative;
      width: 100%;
      padding: 0 12px;
      border-radius: var(--Radius-100);
      border: 1px solid ${gray.$400};
      outline: none;
      color: ${gray.$900};
      -webkit-appearance: none; //아이패드 기본 input 스타일 삭제
      &::placeholder {
        ${typo.body02};
        color: ${gray.$500};
      }
      &:hover {
        border-color: ${gray.$500};
      }
      &:focus {
        border-color: ${gray.$500};
      }
      &:disabled {
        color: ${colors.gray.$500};
        background: ${gray.$100};
        border: 1px solid ${borderColor};
      }
      &[inputmode='numeric'] {
        text-align: center;
      }
    `,
  ],
  wrapper: css`
    position: relative;
    flex: 1;

    .number-buttons-wrap {
      position: absolute;
      display: flex;
      pointer-events: none;
      visibility: hidden;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 16px;
      top: 0;
      bottom: 0;
      right: 2px;

      svg path {
        fill: ${colors.gray.$700};
      }
      button {
        svg path {
          transition: fill 0.2s;
        }

        :hover {
          svg path {
            fill: ${colors.gray.$900};
          }
        }
      }
    }
    :hover {
      .number-buttons-wrap {
        visibility: visible;
        pointer-events: visible;
      }
    }
  `,
  eyeButton: css`
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
  `,
}
